import { useState } from "react";

import { useTranslation } from "lib/i18n/use-translation";

import FullScreenExitIcon from "assets/icons/full-screen-exit.svg?react";
import FullScreenIcon from "assets/icons/full-screen.svg?react";
import css from "./fullscreen.module.scss";

export function Fullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { t } = useTranslation();

  async function toggleFullscreen() {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } else {
        await document.exitFullscreen();
        setIsFullscreen(false);
      }
    } catch (error) {
      console.warn("Fullscreen not supported or failed:", error);
    }
  }

  const title = isFullscreen
    ? t("Выйти из полноэкранного режима")
    : t("Полноэкранный режим");

  return (
    <button onClick={toggleFullscreen} className={css.trigger} title={title}>
      {isFullscreen ? <FullScreenExitIcon /> : <FullScreenIcon />}
    </button>
  );
}
